module.exports = __webpack_public_path__ + "static/media/sinergia.88a57837.svg";